import React, { useState } from 'react'
import { makeStyles, Grid, Paper, Card, Box, Button, Input, Typography, CardContent, CardActions } from '@material-ui/core';
import { useHistory, useParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, } from 'react-leaflet'
import Weather from '../../Landingpage/city info/wather/Wather'
// HealthRank
import { IncreaseHealthRank, IncreaseEducationRate, IncreaseConstructionRage } from '../../redux/action/action.js'
import { useDispatch, useSelector } from 'react-redux';
import Web3 from 'web3';
import Loader from '../../loading';
const useStyles = makeStyles((theme) => ({

  box1: {
    paddingTop: "10px",
    width: "100%"
  },
  courseInfo: {
    padding: "10px",
    textAlign: "center",
  },
  buyContainer: {

    [theme.breakpoints.down("md")]: {
      marginTop: 0
    }

  }

}));
export default function BuyCites() {
  const [healthrank, setHealthrank] = useState(0)
  const [educatinrate, setEducatinrate] = useState(0)
  const [construction, setConstructionRate] = useState(0)
  const classes = useStyles();
  let params = useParams()
  const dispatch = useDispatch()
  const state = useSelector(state => state.UserReducer)
  const { userConstruct } = state
  const Aut = useSelector(state => state.AutReducer)
  const { id } = params
  const GetUniqueCity = Aut.usebuycities && Aut.usebuycities.find((item) => {
    return +item.zip === +id
  })
  var position = [GetUniqueCity && GetUniqueCity.latitude, GetUniqueCity && GetUniqueCity.longitude]

  const HealthRankHandler = async (zip) => {
    await dispatch(IncreaseHealthRank(healthrank, zip))
  }

  const EducationRank = async (zip) => {
    await dispatch(IncreaseEducationRate(educatinrate, zip))
  }

  const ConstructionRateHandler = async (zip) => {
    await dispatch(IncreaseConstructionRage(construction, zip))
  }


  return (

    <div>
      { GetUniqueCity ? GetUniqueCity && <Box mx="auto" style={{ backgroundColor: "#fff", borderRadius: "10px" }} p="10px">
        <Grid item xs={12} sm={12} md={12} >
          {GetUniqueCity ? GetUniqueCity && <Weather Cityname={GetUniqueCity && GetUniqueCity.name} CountryName="us" /> : "Loading.........."}
        </Grid>

        <Grid container justify="center" direction="row-reverse" spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <div>
              <MapContainer style={{ zIndex: 0 }}

                center={GetUniqueCity && position}
                zoom={13} scrollWheelZoom={false}>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <CircleMarker
                  center={GetUniqueCity && position}
                  pathOptions={{ color: 'red' }}
                  radius={40}>
                </CircleMarker>
                <Marker
                  position={GetUniqueCity && position}
                >
                  <Popup>
                    City : {GetUniqueCity.name} <br />
                    State : {GetUniqueCity.name} <br />
                    latitude : {GetUniqueCity.latitude} <br />
                    longitude : {GetUniqueCity.longitude} <br />
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </Grid>

          <Grid container item xs={12} sm={12} md={6} justify="flex-start" className={classes.buyContainer}>
            <Grid item lg={6}>
              <Box p={1}>
                <Card className={classes.root} >
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span> HEALTH RANK</span> 	&nbsp; {userConstruct.health_development_rate ? userConstruct?.health_development_rate : 0}
                    </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your HEALTH RANK by adding your desire values
                    </Typography>
                    <br />
                    <Input color="secondary" value={healthrank} onChange={(e) => setHealthrank(e.target.value)} fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth onClick={() => HealthRankHandler(GetUniqueCity.zip)}>Health Rank</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
            <Grid item lg={6}>
              <Box p={1}>
                <Card className={classes.root} >
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span>Education Level</span> 	&nbsp; {userConstruct.education_development_rate ? userConstruct?.education_development_rate : 0}
                    </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your Education Level by adding your desire values
                          </Typography>
                    <br />
                    <Input color="secondary" onChange={(e) => setEducatinrate(e.target.value)} fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth onClick={() => EducationRank(GetUniqueCity.zip)}>Submit</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
            <Grid item lg={6}>
              <Box p={1} >
                <Card className={classes.root} variant="outlined">
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span>Construction Level</span> 	&nbsp;{userConstruct.construction_development_rate ? userConstruct?.construction_development_rate : 0}
                    </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your ConstructionRate  by adding your desire values
                          </Typography>
                    <br />
                    <Input color="secondary" onChange={(e) => setConstructionRate(e.target.value)} fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth onClick={() => ConstructionRateHandler(GetUniqueCity.zip)}>Submit</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
            <Grid item lg={6}>
              <Box p={1} >
                <Card className={classes.root} variant="outlined">
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span>Education Level</span> 	&nbsp; 0.999
                      </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your Education Levelby adding your desire values
                          </Typography>
                    <br />
                    <Input color="secondary" fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth>Submit</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
            <Grid item lg={6}>
              <Box p={1} >
                <Card className={classes.root} variant="outlined">
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span>Education Level</span> 	&nbsp; 0.999
                      </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your Education Levelby adding your desire values
                          </Typography>
                    <br />
                    <Input color="secondary" fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth>Submit</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
            <Grid item lg={6}>
              <Box p={1} >
                <Card className={classes.root} variant="outlined">
                  <CardContent>
                    <Typography variant="h5" style={{ color: "#FF5805", textAlign: "center", fontFamily: "Bangers,cursive" }} gutterBottom>
                      <span>Education Level</span> 	&nbsp; 0.999
                      </Typography>
                    <Typography variant="h5" component="h2">

                    </Typography>
                    <Typography color="textSecondary">
                      Increase your Education Levelby adding your desire values
                          </Typography>
                    <br />
                    <Input color="secondary" fullWidth />
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="secondary" variant="outlined" fullWidth>Submit</Button>
                  </CardActions>
                </Card>
              </Box>
            </Grid>
          </Grid>
          <Grid>

          </Grid>
        </Grid>


      </Box> :


        <Box style={{ height: "100vh", width: "100%", backgroundColor: "#fff", borderRadius: "10px", paddingTop: ".0.9rem", overflow: "hidden" }}>
          <Loader />
        </Box>
      }
    </div>
  )
}
